const MAP = {
  live: { label: "Live", color: "#1D9E75", bg: "#E6F7F0" },
  awaiting: { label: "Awaiting Live Integration", color: "#BA7517", bg: "#FBF3E4" },
  issue: { label: "Connection Issue", color: "#C0392B", bg: "#FBE9E7" },
};

export function StatusBadge({ status, lastSync, compact }) {
  const s = MAP[status] || MAP.awaiting;
  return (
    <span data-testid={`status-badge-${status}`}
          style={{ display: "inline-flex", alignItems: "center", gap: 6, background: s.bg, color: s.color,
                   padding: compact ? "2px 8px" : "4px 10px", borderRadius: 14, fontSize: 11, fontWeight: 700 }}>
      <span style={{ width: 7, height: 7, borderRadius: "50%", background: s.color }} />
      {s.label}{!compact && lastSync ? ` · synced ${new Date(lastSync).toLocaleTimeString()}` : ""}
    </span>
  );
}
